import { REACT_APP_MUSICME_API_URL } from './env'

let _settings: { partner_name: string, partner_key: string } | null = null
export function setSettings(settings: { partner_name: string, partner_key: string } | null) {
  _settings = settings
  console.log('SETTINGS', settings)
}

export function decrypt(data : string) {
  data = data.substr(10, data.length - 18);
  let pos = -1;
  for (let i = 0; i < 10 && pos < 0; i++) {
    const c = data[i];
    if (i % 2 === 1 && (c === "8" || c === "B")) {
      pos = i + 1;
    }
  }
  if (pos === -1) {
    pos = 10;
  }
  data = data.substr(pos);
  const test = data.split('');

  const firstLength = test.length / 2 - (test.length / 2) % 2;
  const secLength = test.length - firstLength;
  let chars = [];
  for (let j = 0; j < firstLength; j++)
    chars[j + secLength] = test[j];
  for (let j = 0; j < secLength; j++)
    chars[j] = test[firstLength + j];
  var decryptedChars = [];
  for (let i = 0; i < chars.length / 2; i++) {
    const b = parseInt('0x' + chars[i * 2] + chars[i * 2 + 1]);
    decryptedChars[i] = (b ^ 170);
  }
  const res = decryptedChars.map(c => String.fromCharCode(c));
  return res.join('');
}

function medianumUrl(request: string, ignoreSettings = false) {
  if (_settings === null && !ignoreSettings)
    throw new Error()

  return REACT_APP_MUSICME_API_URL +
      '/medianum/' +
      request +
      '&format=json' +
      '&client={"type":"web","context":"playlist-editor"}' +
      (_settings != null ? `&partner=${_settings.partner_name}&key=${_settings.partner_key}` : '')
}

export function getLoginUrl(email: string, pwd: string) {
  return medianumUrl(`medialibrary/signin?login=${email}&password=${pwd}`, true)
}

export function getPlaylistsUrl(userId: string, playlistId?: string) {
    if (playlistId && playlistId.includes('-'))
        playlistId = playlistId.split('-')[1];
    return medianumUrl(`my/playlists${ playlistId ? ('/' + playlistId) : '' }?userid=${userId}&filters={includeForeign:1}`)
}

export function getPlaylistUrl(userId: string, playlistId?: string) {
    if (playlistId && playlistId.includes('-'))
        playlistId = playlistId.split('-')[1];
    return medianumUrl(`playlist${playlistId ? ('/' + playlistId) : ''}?userid=${userId}&resources=tracks`)
}

type searchResource = 'artists'
                    | 'albums'
                    | 'artists,albums'
                    | 'albums,artists'
export function getSearchUrl(query: string, resources: searchResource) {
    return medianumUrl(`search?query=${query}&resources=${resources}&filters={"maxResults":5}`)
}

export function getSimilarUrl(artist: number) {
  return medianumUrl(`artist/${artist}?resources=related-artists{maxResults:6}`)
}

export function getSearchAlbumsUrl(query: string) {
    return getSearchUrl(query, 'albums')
}

export function getSearchArtistsUrl(query: string) {
    return getSearchUrl(query, 'artists')
}

export function getSearchAllUrl(query: string) {
    return getSearchUrl(query, 'artists,albums')
}

export function getDiscoUrl(artistId: number, count?: number) {
    let url = `artist/${artistId}?resources=albums`
    if (!!count) {
      url += `&filters={"maxResults":${count}}`
    }
    return medianumUrl(url)
}

export function getAlbumUrl(upc: string) {
    return medianumUrl(`album/${upc}?resources=tracks`)
}